<template>
    <router-view/>
</template>

<script>
export default {
	name: 'App',
	
	
	mounted() {
	    
	},
	

	methods: {
	   　 

	} 
	    
	    
	 
	  
 
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50
}
	
 
*{
	margin: 0;
	padding: 0;
}
  
a{
	text-decoration: none;color: #606060;cursor:pointer;
}

 

/* nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

 */
	
 	 
	
	.catrage_img{
		width:100%;
		 
	}
	.catrage_img img{
		width:100%;
		background-size: cover;
		background-color: #eee;
		background-repeat: no-repeat;
	}
	.catrage_page{
		width:100%;
		height:auto;
		margin-bottom:10px;
	}
	.catrage_page .catrage_page_title{
		width: 100%;color: #333;font-size: 30px;margin-top: 25px;
	}
	
	.catrage_page_content{
		width: 1200px;
		text-align: center;
		margin: 0px auto;
		overflow: hidden;
		line-height: 35px;
	}
	
	.catrage_page_list{
		    width: 1200px;
		    height: auto;
		    margin: 0px auto;
		    overflow: hidden;
	}
	 
	.content_list{
		width:99%;
		border-bottom: 1px solid #eee;
		height:200px;
		line-height:30px;
		margin-bottom:20px;
		 
	}
		
	.content_list div{
		float: left;
	}
	.content_list_pic{
		width:25%;
		height:100%;
		padding:10px;
		 
	}
	.content_list_pic img{
		width:100%;
		height:90%;
		 
	}
	.content_list_content{
		    width: 70%;
		    height: 87%;
		    margin: 13px 19px;
	}
	.content_list_content .content_list_title{
		text-align: left;
		font-size: 18px; 
	 
	}
	.content_list_content .content_list_desc{
		text-align: left; 
		display: inline-block;
		line-height: 30px;
		margin: 15px 0px;
	}
	.page{
		    margin: 0px auto;
		    overflow: hidden;
		    margin-left: 500px;
	}
	 
    .model_css_1{
		background-size: 100%;background-attachment: fixed; 
	}
</style>
